module.exports = __webpack_public_path__ + "img/jiazhao.1c86fdf5.png";